/**
 * Les adresses propres au module **dashboards**.
 *
 * ★ Elles vivent ici et non dans `lib/chemins.ts` pour la même raison que
 * `CHEMIN_APPARENCE` et `CHEMIN_REGIE` : `lib/` appartient à la fondation, et
 * plusieurs lots y écrivent en même temps. Le routeur, lui, n'a rien à
 * apprendre — il monte `routesDashboards` sous `/admin/tableaux` et le segment
 * ci-dessous en est un enfant.
 *
 * ⚠️ Le segment de paramètre s'appelle `:representation` et pas `:id` : c'est le
 * nom que le harnais de rendu des écrans (`lib/ecrans-harnais.tsx`) sait
 * substituer par une représentation de son monde simulé. Un `:id` quelconque y
 * recevrait un identifiant inconnu, et la fiche serait rendue — donc
 * « vérifiée » — dans son seul état « introuvable ».
 */

import { CHEMINS } from '../../lib/chemins'

/** Le motif de route, monté par `routesDashboards`. */
export const SEGMENT_REPRESENTATION = 'representations/:representation'

/**
 * La fiche d'une soirée : `/admin/tableaux/representations/<id>`.
 *
 * ★ Elle prend une `recherche` — la chaîne de requête de la liste d'où l'on
 * vient (onglet, saison, page, tri, filtre). C'est ce qui permet au lien de
 * retour de reposer l'utilisateur SUR SA PAGE, et non en tête de liste. Sans
 * elle, paginer et ouvrir une fiche se contrediraient : on gagnerait une liste
 * qui tient à l'écran pour perdre sa position à chaque clic.
 */
export function cheminRepresentation(representationId: string, recherche = ''): string {
  const suffixe = recherche === '' ? '' : `?${recherche.replace(/^\?/u, '')}`
  return `${CHEMINS.tableaux}/representations/${representationId}${suffixe}`
}

/** Le retour vers la liste, avec l'état exact dans lequel on l'avait laissée. */
export function cheminRetourTableaux(recherche = ''): string {
  const suffixe = recherche === '' ? '' : `?${recherche.replace(/^\?/u, '')}`
  return `${CHEMINS.tableaux}${suffixe}`
}
